const situations = [
  'обучение сотрудников проводится одинаково для всех',
  'непонятно, какие компетенции действительно требуют развития',
  'руководители по-разному оценивают сотрудников',
  'сложно определить сотрудников с высоким потенциалом',
  'нет понятного кадрового резерва',
  'сотрудников повышают без оценки готовности к новой роли',
  'сильные сотрудники развиваются стихийно',
  'обучение не связано с результатами оценки',
  'сотрудники не понимают, какие компетенции им необходимо развивать',
  'компания быстро растёт',
  'создаются новые подразделения',
  'внедряется новая система управления',
  'необходимо подготовить будущих руководителей',
  'компания хочет систематизировать развитие персонала',
];

export default function WhenNeeded() {
  const scrollTo = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Когда компании нужна оценка сотрудников
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Есть признаки, которые показывают: пора проводить оценку сотрудников и компетенций.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {situations.map((s, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl border border-gray-100 hover:border-teal-200 transition-colors">
              <div className="w-8 h-8 bg-teal-600 text-white rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-sm font-bold">{i + 1}</span>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{s}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={scrollTo}
            className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Обсудить задачу оценки
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}